import apiClient from "../../../service/apiClient";
import { USER_PROFILE_ENDPOINTS } from "../../../app/apiEndpoints";

const unwrap = (response) => response?.data;

const requestConfig = { withCredentials: true };

export const updatePassword = async (payload) =>
  unwrap(
    await apiClient.post(
      USER_PROFILE_ENDPOINTS.UPDATE_RESET_PASSWORD,
      payload,
      requestConfig
    )
  );

export const getChallengePhrases = async () =>
  unwrap(
    await apiClient.get(
      USER_PROFILE_ENDPOINTS.GET_CHALLENGE_PHRASES,
      requestConfig
    )
  );

export const getChallengePhrasesAnswer = async (userId) =>
  unwrap(
    await apiClient.get(
      USER_PROFILE_ENDPOINTS.GET_CHALLENGE_PHRASES_ANSWER,
      {
        ...requestConfig,
        params: { userId, challengePhraseAnswerId: 0 },
      }
    )
  );

export const insertOrUpdateChallengePhrasesAnswer = async (payload) =>
  unwrap(
    await apiClient.post(
      USER_PROFILE_ENDPOINTS.INSERT_OR_UPDATE_CHALLENGE_PHRASES_ANSWER,
      payload,
      requestConfig
    )
  );

export const getUserInfo = async (contactId) =>
  unwrap(
    await apiClient.get(
      USER_PROFILE_ENDPOINTS.GET_USER_INFO,
      {
        ...requestConfig,
        params: { contactId },
      }
    )
  );

export const getUserAdmin = async ({
  userType = "any",
  userId = 0,
  userName = "",
} = {}) =>
  unwrap(
    await apiClient.get(
      USER_PROFILE_ENDPOINTS.GET_USER_ADMIN,
      {
        ...requestConfig,
        params: { userType, userId, userName },
      }
    )
  );

export const updateNotificationPreferences = async (payload) =>
  unwrap(
    await apiClient.post(
      USER_PROFILE_ENDPOINTS.UPDATE_NOTIFICATION_PREFERENCES,
      payload,
      requestConfig
    )
  );

export const resetAuthKey = async (payload) =>
  unwrap(
    await apiClient.post(
      USER_PROFILE_ENDPOINTS.RESET_MFA,
      payload,
      requestConfig
    )
  );

export const verifyMfaCode = async (otpCode) =>
  unwrap(
    await apiClient.get(
      USER_PROFILE_ENDPOINTS.VERIFY_MFA_CODE,
      {
        ...requestConfig,
        params: { otpCode },
      }
    )
  );